import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_green_up",
  "use": "icon-ic_green_up-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_green_up\">\r\n<path d=\"M13.5917 3.6748H10.0917L11.375 4.95814L8.34167 8.0498L5.13333 4.84147L0 9.91647L0.875 10.7915L5.13333 6.53314L8.34167 9.74147L12.25 5.83314L13.5917 7.1748V3.6748Z\" fill=\"#01BC9B\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol